import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchWarrantyErrorCodesList = () =>
  (dispatch) => {
    return dispatch(
      apiActionCreator({
        'endpoint': '/warranties/error-codes',
        'authenticated': true,
        'types': [
          ActionTypes.FETCHING_WARRANTY_ERROR_CODES_LIST,
          ActionTypes.FETCHED_WARRANTY_ERROR_CODES_LIST,
          [
            ActionTypes.FETCHED_WARRANTY_ERROR_CODES_LIST_FAILED,
            (error) => buildErrorMessage(error),
          ],
        ],
        'microservice': 'part',
        'method': 'GET',
      })
    );
  };

export const fetchWarrantyErrorCode = (code) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/error-codes/${code}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_WARRANTY_ERROR_CODE,
        ActionTypes.FETCHED_WARRANTY_ERROR_CODE,
        [
          ActionTypes.FETCHED_WARRANTY_ERROR_CODE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const addWarrantyErrorCode = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/error-codes',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_WARRANTY_ERROR_CODE,
        [
          ActionTypes.ADDED_WARRANTY_ERROR_CODE,
          MessageActions.addMessageBoxInfo('Código creado satisfactoriamente'),
        ],
        [
          ActionTypes.ADDED_WARRANTY_ERROR_CODE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWarrantyErrorCode =
  (code, data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/warranties/error-codes/${code}`,
          'authenticated': true,
          'types': [
            ActionTypes.UPDATING_WARRANTY_ERROR_CODE,
            [
              ActionTypes.UPDATED_WARRANTY_ERROR_CODE,
              MessageActions.addMessageBoxInfo(
                'Código actualizado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.UPDATED_WARRANTY_ERROR_CODE_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'PUT',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const clearWarrantyErrorCodes = () => ({
  'type': ActionTypes.CLEAR_WARRANTY_ERROR_CODES_LIST,
});
